/**
 * Store complete book models (photos, backgrounds, stickers, etc...)
 */
fx.ns("repositories", class BaseRepository extends fx.Model {

    constructor( model, saver, history)
    {
        super(null, {saver : saver !== false ? shared.EditorSaver : null, history : history !== false ? shared.EditorHistory : false });

        if (!models)
            models = {};

        let defaults = {
                            creation : {}, // 
                            account : new models.User({id:""}),
                            servers : new repositories.ServersRepository(),
                            fonts : new repositories.FontsRepository(),
                            masks : new fx.ModelArray(),
                            photos : new repositories.PhotosRepository(),
                            stickers : new repositories.StickersRepository(),
                            shapes : new repositories.ShapesRepository(),
                            backgrounds : new repositories.BackgroundsRepository() ,
                            texts :  new repositories.TextsRepository(),
                            layouts : new repositories.LayoutsRepository(),
                            customcolors : new repositories.CustomColorsRepository(),
                            google: new repositories.GoogleRepository(),
                            albums: new repositories.AlbumsRepository(),
                            sharedPhotos : new fx.ModelArray(),
                            guests : new fx.ModelArray(),

                            productTypes : new fx.ModelArray([]),
        };
        
        this.init({...defaults, ...model}); 

        this.NB_UPDATES_BEFORE_SAVING = 20;

        fx.set("fonts", this.fonts);
        fx.set("servers", this.servers);
        fx.set("texts", this.texts); // TODO : move to books
        fx.set("lang", new models.Lang({}));

        fx.set("productTypes", this.productTypes); 

        this.prop("photofilters" , new filters.PhotoFilters());

        this._saving = false;   
        this._autoSave = true;
        this._needUpdateReport = false;
    }

    get autoSave()
    {
        return this._autoSave;
    }

    set autoSave(val)
    {
        this._autoSave = val;
    }

    get saving()
    {
        return this._saving; 
    }

    set saving(val)
    {
        this._saving = val; 
    }

    // compatibility with config
    get creationModel()
    {
        return this;
    }

    get requestDefaultParams()
	{
		return {connectionid : this.connectionid};
	}

    get creationid()
    {
        return this._creationid;
    }

    set creationid(val)
    {
        this._creationid = val;
    }

    get productid()
    {
        return this._productid;
    }

    set productid(val)
    {
        this._productid = val;
    }

    get connectionid()
    {
        return fx.get("connectionid");
    }

    set connectionid(val)
    {
        fx.set("connectionid", val);
    }

    /*get modified()
    {
        // if _modified was never set, we use saver data to know if model was updated
        return super.modified || (this.creation && !this.creation.started && !this.creation.deleted); // In case of IA book, it is deleted when created
    }*/

    get visibleMasks()
    {
        return this.masks.filter( (mask) => mask.visible );
    }

    get updatesSavedLocally()
    {
        if (!this._updatesSavedLocally)
            this._updatesSavedLocally = this.read("updatesSavedLocally");

        return this._updatesSavedLocally;
    }

    set updatesSavedLocally(data)
    {
        if (data == null)
            this.remove("updatesSavedLocally");
        else
            this.store("updatesSavedLocally", data);

        this._updatesSavedLocally = data;
    }


    get photosorts()
    {
        let sorts = [ new filters.SortPhotosAdded("DESC", true), new filters.SortPhotosChronological(this) ];
        if (this.guests.length > 0)
            sorts.push(  new filters.SortPhotosByPerson(this.guests) );
        
        return sorts;
    }

    report(raw)
    {
        this._needUpdateReport = false;
        
        return { pages : [], failed : false};
    }

    // ----------------------- //

     /**
     * We override here this function because we need to automate saving
     */
     onUpdated(action)
     {
         super.onUpdated(action);
 
         // when a media (Photo/Background/Sticker/...) is used/unused anywhere in application, 
        // here we count how many times
        if (action.impacts("content") && action.model instanceof models.CreationElementContent)
        {
            if (action.tag == "update-id")
                return;

            if (action.previous.content != action.model.content)
            {
                this.useMedia( action.model.component_type, action.previous.content, false );
                this.useMedia( action.model.component_type, action.model.content, true );
            } 
        }

        if (action.type == "removeItem" && action.data instanceof models.CreationElementContent)
            this.useMedia( action.data.component_type, action.data.content, false );
    
        if ( (action.type == "addItem" || action.type == "addItemAt") && action.data instanceof models.CreationElementContent)
            this.useMedia( action.data.component_type, action.data.content, true );

        // case when a picture is deleted, so all pages containing that picture have to be updated
        if (action.type == "update" && action.impacts("deleted") && action.model instanceof models.Photo && action.data.deleted)
            this.book.removePhoto( action.model );
        
         // we save automatically our model everytime we reach a number of udpdates
         if (this.autoSave && this.saver && this.saver.lastUpdates.length > this.NB_UPDATES_BEFORE_SAVING)
             this.delay(this.save, 250);

         this._needUpdateReport = true;
     }


    onDataEvent(e)
    {
        super.onDataEvent(e);

        if (e.type == "login-succeed" || e.type == "register-succeed")
        {
            this.creation.accountid = this.account.id;
            this.connectionid = this.account.token;
        }

        if (e.type == "creation-loaded")
            this.fonts.addEmpty();
    
        if (e.type == "font-family-updated")
        {
            this.creation.last_font_family = e.detail;

            this.fonts.changeCount(e.detail);
        }
        
        if (e.type == "font-size-updated")
            this.creation.last_font_size = e.detail;

        if (e.type == "align-updated")
            this.creation.last_align = e.detail;

        if (e.type == "load-layout-medias")
        {
            for(let i = 0; i < e.detail.length; i++)
            {
                let media = e.detail[i];
                switch(media._m)
                {
                    case "Background":
                        this.backgrounds.addItem( new models.Background(media) );
                    break;

                    case "Sticker":
                        this.stickers.addItem( new models.Sticker(media) );
                    break;
                }
            }
        }  
        
        // case when picture is uploaded, and get it's final id
        // we need to update all pages containing temporary photo id with this final id.
        if (e.type == "media-file-uploaded")
            this.creation.updatePhotos(e.model.id, e.model.oldid);

        // user selected photos from an album
        if (e.type == "album-photos-copied")
            this.photos.addItem(e.detail);
    }

    /**
     * We can load a book from an id
     * @param {int} bookid 
     */
    load(creationid, lang)
    {
        if (!creationid)
            creationid = this.creationid;
        
        if (this.updatesSavedLocally)
            this._rescueUpdates();
        else
            this.post("/app/load", { 
                                        creationid : creationid, 
                                        fonts : this.fonts.length == 0,
                                        lang : lang ? lang : fx.currentLang() 
                                    }, this._loaded);
        
        this.event("creation-loading");
    }

    loadOptions()
    {
        if (!this.creation.creationOptions)
            this.post( "/app/creationoptions", {product_type_id : this.creation.product_type_id}, this.optionsLoaded);
        else
            this.event("creation-options-loaded")
    }

    optionsLoaded(data)
    {
        if (data.error)
            this.event("load-creation-options-error", data);
        else
        {
            this.creation.creationOptions = data;
            this.event("creation-options-loaded");
        }
    }

    _rescueUpdates()
    {
        let data = {    action : "save",
                        updates : this.updatesSavedLocally,
                        id : this.creationid, 
                        contextid : "", 
                        connectionid : this.connectionid,
                        exit : "updatesSavedLocally", 
                        device : fx.browser.device
            
        };
    
        this.post( "/app/save", data, this._onRescueUpdates );
    }

    _onRescueUpdates(data)
    {
        this.updatesSavedLocally = null;
        this.load(this.creationid);
    }

    loadPreview()
    {
        //this.creationid = creationid;

        this.post("/app/preview", {action:"preview", creationid : this.creationid }, this._loaded);
        
        this.event("creation-loading");
    }

    _loaded(data)
    {
        if (data && data.error)
        {
            this.event("load-creation-error", data.details.message);
        }
        else
        {
            this.initData(data);
            this.event("creation-loaded", this.creation);
        }
    }


    // TO override
    initData(data)
    {
        fx.get("lang").init( data.lang );

        this.account.init( data.account );
        this.connectionid = this.account.token;

        if (data.settings)
            fx.get("settings").init(data.settings);

        if (this.history)
			this.history.maxActionsStored = fx.get("settings").maxHistoryActionsStored;

        if (data.servers)
        {
            if (this.servers.length > 0)
                this.servers.addItem(data.servers);
            else
                this.servers.init(data.servers);
        }

        if (data.fonts)
            this.fonts.init(data.fonts);

        this.productTypes.init(data.productTypes);

        this.masks.init(data.masks);
        this.photos.addItem(data.photos);
        this.stickers.init(data.stickers);
        this.backgrounds.init(data.backgrounds);

        this.backgrounds.categories = data.backgrounds_categories;
        this.stickers.categories = data.stickers_categories;

        if (data.texts)
            this.texts.init(data.texts);

        if (data.layouts)
            this.layouts.init(data.layouts);

        if (data.customcolors)
            this.customcolors.init(data.customcolors);
        
        this.prop("photofilters" , new filters.PhotoFilters());

        this.event("repository-initialized");
    }

    create()
    {
        this.post( "/app/create", {  product_id : this.productid, formatid : this.choosedFormat }, this.onCreateData);

        this.event("create-creation");
    }

    onCreateData(data)
    {
        if (data.error)
        {
            this.event("create-creation-error", data);
            return;
        }

        this.initData(data);
        this.event("creation-created", this.creation);
    }

    loadLayoutMedias(medias)
    {
        this.post("/app/loadmedia" , {medias : medias}, this._loadedLayoutMedias);
    }

    _loadedLayoutMedias(data)
    {
        if (data.error)
            this.event("load-layout-medias-error", data);
        else
        {
            this.event("load-layout-medias", data);

            this.event("layout-medias-loaded");
        }
    }

    // -------------------- //
    save(saveReason)
    {
        let force = (saveReason === true || saveReason == "cover-saved");

        if (saveReason == "cover-saved")
            saveReason = this._saveReason;

        if (!this.creation.id || !this.modified)
        {
            this.saving = false;
            this.event("creation-saved");
            return;
        }
          
        if (this.saving && !force)
        {
            if (saveReason)
                this.event("creation-saving");
            return;
        }

        this.saving = true;
        this.event("creation-saving");

        if(this.creation.cover.modified) // !deleted for books created by IA, there are first created with deleted == 1, and deleted is set to 0 only if user goes to the last step of IA process.
        {
            this._saveReason = saveReason;
            this.on("thumb-generated", this._onCoverGenerated, fx.service("ThumbGenerator"));
            fx.service("ThumbGenerator").generate(this.creation);  
        }
        else  
        {
            if (this.creation.started == 0)
                this.creation.started = 1;

            this._saveReason = undefined;

            if (saveReason == "exit-editor" || saveReason == "order-confirmed")
            {
                this.checkUploadedPhotos();
    
                let report = Utils.stringify(this.report(true), 3);
                if (report != this.creation.report)
                    this.creation.update({report : report});
            }
            
            super.save({    url : "/app/save", 
                            force : force,            
                            params : {  id : this.creation.id, 
                                        contextid : this.creation.contextid, 
                                        connectionid : this.connectionid,
                                        exit : saveReason, 
                                        device : fx.browser.device,
                                        coverthumb : fx.service("ThumbGenerator").base64 || undefined }
                        });
        }
    }

    _onCoverGenerated()
    {
        this.off("thumb-generated", this._onCoverGenerated, fx.service("ThumbGenerator"));
        this.creation.cover.modified = false;
        this.save("cover-saved")
    }


     onSaved(data)
    {
        super.onSaved(data);

        this.saving = false;

        if (!data.error)
        {
            // saved went fine, we don't store last update in local storage
            this.updatesSavedLocally = null;

            fx.service("ThumbGenerator").clean();
            this.event("creation-saved");

            if (data["context-changed"])
                this.event("new-editor-opened", null,  1000); // we add a delay, so in case we are exiting, popup will never be displayed
        }
        else
        {
            // saved went wrong, we store last update in local storage, so we can get it back at next load
            if (this.saver)
                this.updatesSavedLocally = this.saver.prepareUpdatesForSending(true);
        }   
    }


    // temporary fix for pictures uploaded but content not updated 
    checkUploadedPhotos()
    {
        let ready = true;

        for (let i = 0; i < this.photos.length; i++)
            this.photos.getItemAt(i)._number = 0;
        
        for (let i = 0; i < this.creation.elements.length; i++)
        {
            let page = this.creation.elements.getItemAt(i);

            for (let j = 0; j < page.components.length; j++)
            {
                let component = page.components.getItemAt(j);

                if (component.isPhoto)
                {
                    if (Utils.isID(component.content))
                    {
                        let photo = this.photos.find({temporaryId : component.content});
                        if (photo)
                        {
                            if (Utils.isID(photo.id))
                            {
                                if (!fx.service("MediasUploader").toBeUploaded(photo))
                                {
                                    fx.service("MediasUploader").upload( photo );
                                    ready = false
                                }
                            }
                            else
                                component.update("update-id", {content : photo.id});
                        }
                    }
                   
                    let photo = this.photos.find({id : component.content});
                    if (photo)
                        photo._number++;    
                
                }
            }
        }

        for (let i = 0; i < this.photos.length; i++)
            this.photos.getItemAt(i).number = this.photos.getItemAt(i)._number;

        return ready;
    }


    useMedia( type, id, use )
    {
        if (!id) return;

        switch(type)
        {
            case "background" :
                this.backgrounds.use(id, use);
                break;

            case "sticker" :
                this.stickers.use(id, use);
                break;

            case "photo" :
            case "image" :
                this.photos.use(id, use);
                break;
        
            // TEXTS AND LAYOUTS don't need for now to be flaged as used or not in UI, but we still keep up to date this data if UI changes.
            case "text" :
                this.texts.use(id, use);
                break;
    
            case "layout" :
                this.layouts.use(id, use);
                break
        }
        
    }


    // Albums 
    loadAlbums()
    {
        this.albums.loadAlbums(this.creation.id, this.account.id, this.connectionid);
    }

    loadAlbumPhotos(id)
    {
        this.albums.loadAlbumPhotos(id, this.account.id, this.connectionid);
    }

    copyAlbumPhotos(files)
    {
        this.albums.copyPhotos(files, this.account.id, this.creation.id,  this.connectionid);
    }



});
